import jwtDecode from 'jwt-decode'

export const isJwtTokenExpired = (token: string): boolean => {
  if (!token)
    return true

  const decoded: any = jwtDecode(token)
  return decoded.exp * 1000 < (new Date()).getTime()
}
